import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getTheme } from './theme';
import { getDisplayVariant } from './abtest';
import ThemeController from './ThemeController';
import { TermsPage, PrivacyPage } from './LegalPages';
import AtsScoreChecker from './AtsScoreChecker';
import reportWebVitals from './reportWebVitals';

// Paint the displayed variant's background + data-theme before React mounts to
// reduce the flash from the dark pre-render. ThemeController owns the live theme
// (and lets the user switch it) once mounted.
const initialVariant = getDisplayVariant();
document.documentElement.dataset.theme = initialVariant;
document.body.style.backgroundColor = getTheme(initialVariant).palette.background.default;

// Lightweight path-based routing (no router dependency). The nginx SPA fallback
// serves index.html for these paths, and we pick the view from the pathname.
function Routed() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/terms') return <TermsPage />;
  if (path === '/privacy') return <PrivacyPage />;
  if (path === '/ats-score') return <AtsScoreChecker />;
  return <App />;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeController>
      <Routed />
    </ThemeController>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
